import React, { useState, useEffect } from 'react'
import './Footer.css'
import store_logo from '../Assets/jenitaslogo-small-height.png'
import facebook from '../Assets/facebook 64x64px.png'
import instagram from '../Assets/instagram 64x64px.png'
import whatsapp from '../Assets/whatsapp 64x64px.png'
import tiktok from '../Assets/tik-tok 64x64px.png'
import youtube from '../Assets/youtube 64x64px.png'
import twitter from '../Assets/twitter x 64x64px.png'
import { Link } from 'react-router-dom'

const Footer = () => {

    const [socialLinks, setSocialLinks] = useState({});

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/site-settings`)
            .then(r => r.json())
            .then(d => { if (d.success) setSocialLinks(d.settings) })
    }, [])
  
  return (
    <div className='footer'>
        <div className="footer-main">
            {/* column 1 */}
            <div className="footer-column">
                <img src={store_logo} alt="Store Logo" className='footer-logo' />
                {socialLinks.contactNumber && (
                    <p className="footer-text">{socialLinks.contactNumber}</p>
                )}
            </div>

            {/* column 2 */}
            <div className="footer-column">
                <h3>Category</h3>
                <ul className="category-links">
                    <li><Link to='/shop-products?category=men' onClick={() => window.scrollTo(0, 0)}>Men</Link></li>
                    <li><Link to='/shop-products?category=women' onClick={() => window.scrollTo(0, 0)}>Women</Link></li>
                    <li><Link to='/shop-products?category=kids' onClick={() => window.scrollTo(0, 0)}>Kids</Link></li>
                    <li><Link to='/shop-products?category=other' onClick={() => window.scrollTo(0, 0)}>Other</Link></li>
                </ul>
            </div>

            {/* column 3 */}
            <div className="footer-column">
                <h3>Opening Hours</h3>
                <p className="footer-text">Weekdays 8.30am – 8.00pm</p>
                <p className="footer-text">Weekends 10.00am – 7.00pm</p>
                <p className="footer-text">Poya Days & Holidays<br/>10.00am – 5.00pm</p>
            </div>

            {/* column 4 */}
            <div className="footer-column">
                <h3 className='social-title'>Connect With Us</h3>
                <div className="footer-social-icons">
                    {socialLinks.facebookUrl && 
                        <a href={socialLinks.facebookUrl} target='_blank' rel="noreferrer" data-tooltip="Facebook Page">
                            <div className="facebook-icon">
                                <img src={facebook} alt="Facebook" />
                            </div>
                        </a>
                    }

                    {socialLinks.instagramUrl && 
                        <a href={socialLinks.instagramUrl} target='_blank' rel="noreferrer" data-tooltip="Instagram Page">
                            <div className="instagram-icon">
                                <img src={instagram} alt="Instagram" />
                            </div>
                        </a>
                    }

                    {socialLinks.whatsappNumber && 
                        <a href={`https://wa.me/${socialLinks.whatsappNumber}`} target='_blank' rel="noreferrer" data-tooltip="Chat on WhatsApp">
                            <div className="whatsapp-icon">
                                <img src={whatsapp} alt="WhatsApp" />
                            </div>
                        </a>
                    }

                    {socialLinks.tiktokUrl && 
                        <a href={socialLinks.tiktokUrl} target='_blank' rel="noreferrer" data-tooltip="TikTok Page">
                            <div className="tiktok-icon">
                                <img src={tiktok} alt="TikTok" />
                            </div>
                        </a>
                    }

                    {socialLinks.youtubeUrl && 
                        <a href={socialLinks.youtubeUrl} target='_blank' rel="noreferrer" data-tooltip="YouTube Channel">
                            <div className="youtube-icon">
                                <img src={youtube} alt="YouTube" />
                            </div>
                        </a>
                    }

                    {socialLinks.twitterUrl && 
                        <a href={socialLinks.twitterUrl} target='_blank' rel="noreferrer" data-tooltip="Twitter/X Profile">
                            <div className="twitter-icon">
                                <img src={twitter} alt="Twitter" />
                            </div>
                        </a>
                    }
                </div>
            </div>
        </div>

        <div className="footer-copyright">
            <p> Developed by DileeshanaJ &copy; {new Date().getFullYear()}</p>
        </div>
    </div>

  )
}

export default Footer